import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export class SsrLoader implements TranslateLoader {
  translations: any;

  constructor(translations: any) {
    this.translations = translations;
  }

  getTranslation(lang: string): Observable<any> {
    return new Observable((observer) => {
      observer.next(this.translations[lang]);
      observer.complete();
    });
  }
}
